exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bezel-list[data-v-021bc8c3]{margin-top:10px;display:flex;flex-direction:row;align-items:center}.bezel-item[data-v-021bc8c3]{margin-top:-30px;margin-right:10px;display:flex;flex-direction:column;justify-content:center;align-items:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-021bc8c3&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/OperationManage/UserAdminister/PersonalizedPart/Components/RunningSkin.vue
// module id = 427
// module chunks = 0